module.exports = __webpack_public_path__ + "medical-and-health.d9e0fe2c278de32b634d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.eot
// module chunks = styles